import { useCreateMatterContactConnection } from "@/lib/data/react-query/matters/matter-contact-connection";
import type { Contact, MatterContactConnection } from "@/lib/types";
import { useCallback } from "react";

type MatterContactConnectionOverrides = Partial<
  Pick<
    MatterContactConnection,
    | "shareFolderId"
    | "vehicleId"
    | "insuranceId"
    | "medicalTreatmentId"
    | "lienId"
    | "expenseId"
    | "signatureRequestId"
    | "incidentReportId"
  >
>;

export const useCreateMockMatterContactConnection = () => {
  const createMatterContactConnection = useCreateMatterContactConnection();

  const createMockMatterContactConnection = useCallback(
    async (
      contact: Contact,
      matterId: string,
      label: MatterContactConnection["label"],
      overrides: MatterContactConnectionOverrides = {},
    ) =>
      createMatterContactConnection.mutateAsync({
        contactId: contact.id,
        label,
        matterId,
        ...overrides,
      }),
    [createMatterContactConnection],
  );

  return {
    createMockMatterContactConnection,
    mutation: createMatterContactConnection,
  };
};
